export const mapTree = (originTree) => {
    if (originTree?.length > 0) {
        const res = originTree.map((item, index) => ({
            key: item.treeId,
            id: item.treeId,
            label: item.name,
            nodeType: item.nodeType,
            children: mapTree(item.children),
        }));
        return res;
    }
    else {
        return [];
    }
};
